import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const TextBlock = ({ listText }) => {
    const hasMinor = listText.minor?.length > 0;

    return (
        <FullWrapper className="text-block">
            {hasMinor ? (
                <div className="text-block__wrapper">
                    <div className="text-block__main">
                        {listText.main.map(item => (
                            <div
                                dangerouslySetInnerHTML={{ __html: item.text }}
                                key={item.id}
                                className="text-block__main-item"
                            />
                        ))}
                    </div>

                    <div className="text-block__minor">
                        {hasMinor &&
                            listText?.minor.map(item => (
                                <div key={item.id} className="text-block__minor-wrapper">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                        className="text-block__minor-description"
                                    />
                                    {item.image2 ? (
                                        <div className="text-block__minor-image">
                                            <img src={item.image1} alt="metrics" />
                                            <img src={item.image2} alt="metrics" />
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            ))}
                    </div>
                </div>
            ) : (
                <div className="text-block__wrapper">
                    <div className="text-block__main">
                        {listText.main.map(item => (
                            <div
                                dangerouslySetInnerHTML={{ __html: item.text }}
                                key={item.id}
                                className="text-block__main-item"
                            />
                        ))}
                    </div>
                </div>
            )}
        </FullWrapper>
    );
};

export default TextBlock;
